import { Phone, MessageCircle, MapPin, HomeIcon, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import type { CommuneData } from '@/data/communes';

interface HeroCommuneProps {
  commune: CommuneData;
}

const HERO_IMAGE = '/images/hero-commune-template.webp';

export function HeroCommune({ commune }: HeroCommuneProps) {
  const { nom } = commune;

  return (
    <section className="relative min-h-[460px] md:min-h-[500px] flex items-center overflow-hidden">
      <img
        src={HERO_IMAGE}
        alt={`Réparation de volets roulants à ${nom} — artisan spécialiste dans le Hainaut`}
        className="absolute inset-0 w-full h-full object-cover object-top"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-500/85 to-secondary-500/70" />
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <nav className="flex items-center gap-1.5 text-sm text-white/70 mb-4 flex-wrap" aria-label="Fil d'ariane">
          <Link to="/" className="hover:text-white transition-colors inline-flex items-center gap-1 whitespace-nowrap">
            <HomeIcon className="w-3.5 h-3.5" />
            Accueil
          </Link>
          <ChevronRight className="w-3.5 h-3.5 shrink-0" />
          <span className="text-white font-medium whitespace-nowrap">Réparation volet roulant {nom}</span>
        </nav>

        <div className="max-w-2xl">
          <p className="text-accent-300 text-sm font-medium mb-2 flex items-center gap-1.5">
            <MapPin className="w-4 h-4" />
            {nom}{commune.codePostal ? ` (${commune.codePostal})` : ''} · Hainaut
          </p>
          <h1 className="text-3xl md:text-5xl font-heading font-bold text-white leading-tight">
            Réparation de volets roulants à {nom}
          </h1>
          <p className="mt-4 text-base md:text-lg text-white/85 leading-relaxed">
            Votre artisan spécialiste en réparation et dépannage de volets roulants à {nom} et dans le Hainaut. Dépannage 7j/7, devis gratuit, garantie 10 ans.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a href="tel:+3280020410" className="btn-primary text-base px-8 py-3.5 inline-flex items-center gap-2 whitespace-nowrap">
              <Phone className="w-5 h-5" />
              Appeler le 0800 20 410
            </a>
            <a
              href="https://wa.me/32475585219"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-secondary text-base px-8 py-3.5 inline-flex items-center gap-2 border-white/30 hover:bg-white/10 whitespace-nowrap"
            >
              <MessageCircle className="w-5 h-5" />
              WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}